'use client';

import { ContactDetailsSectionProps } from '@/components/contact-details/types';
import Card from '@/components/card/Card';
import dynamic from 'next/dynamic';

const GatewayForm = dynamic(
  () => import('@/components/gateway-forms/GatewayForm'),
  { ssr: false },
);

export default function ContactDetails({
  card,
  contactForm,
  spacingTop,
  spacingBottom,
  headlineWrapper,
  sectionId,
}: ContactDetailsSectionProps) {
  return (
    <div
      id={sectionId}
      data-component-id="CO32"
      className={`overflow-h container mx-auto grid w-full grid-cols-4 text-white sm:px-0 lg:grid-cols-12 ${
        spacingTop && spacingBottom
          ? 'py-4 md:py-8 lg:py-20'
          : spacingTop
            ? 'pt-4 md:pt-8 lg:pt-20'
            : spacingBottom
              ? 'pb-4 md:pb-8 lg:pb-20'
              : ''
      }`}
      role="banner"
    >
      {card ? (
        <>
          <div className={'col-span-full my-4 lg:col-start-1 lg:col-end-7'}>
            <GatewayForm {...contactForm} />
          </div>
          <div
            className={
              'lg:full col-span-full my-4 px-4 sm:px-0 lg:col-start-9 lg:col-end-13'
            }
          >
            <Card {...card} />
          </div>
        </>
      ) : (
        <div className="container col-span-full mx-auto my-4">
          <GatewayForm {...contactForm} />
        </div>
      )}
    </div>
  );
}
